import React, { useState } from 'react';

export function useHoverState(delay = 300) {
  const [isHovering, setIsHovering] = useState(false);
  const timeoutRef = React.useRef(null);

  const onMouseEnter = React.useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsHovering(true);
  }, []);

  const onMouseLeave = React.useCallback(() => {
    timeoutRef.current = setTimeout(() => {
      setIsHovering(false);
      timeoutRef.current = null;
    }, delay);
  }, [delay]);

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { isHovering, onMouseEnter, onMouseLeave };
}
